/*eslint-disable*/ export const messages = JSON.parse("{\"select.label.optional\":[\"(valgfrit)\"]}");
//# sourceMappingURL=messages.mjs.map